module.exports = {
          srcSet: __webpack_public_path__ + "b454290c2954e5b6651c03e90015ec39-50.png"+" 50w",
          images:[ {path: __webpack_public_path__ + "b454290c2954e5b6651c03e90015ec39-50.png",width: 50,height: 50}],
          src: __webpack_public_path__ + "b454290c2954e5b6651c03e90015ec39-50.png",
          toString:function(){return __webpack_public_path__ + "b454290c2954e5b6651c03e90015ec39-50.png"},
          
          width: 50,
          height: 50
        }